jQuery(document).ready(function() {
    var fd = '<div class="feature_divider"></div>';
    jQuery(fd).insertAfter('#tracktorContainer #tracktorOrderForm > h1');
    // jQuery('#tracktorContainer #tracktorOrderForm > h1')
    $("#opendraw").on('click', function() {
        $(".smile-launcher-frame-container").hide();
    })
    $("#mm-blocker").on('click', function() {
        $(".smile-launcher-frame-container").show();
    })
    $(".mm-panels li.mm-subtitle").on('click', function(){
        $(".smile-launcher-frame-container").show();
    });
    
});